import React, {
  Suspense,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import {
  checkGracePeriod,
  getGraceFormattedTime,
  getPreExpiryFormattedTime,
  checkPreExpireDate,
  getUserAccessPayload,
  getGeoCountry,
  checkNewUser,
  // getSubscriptionPlan,
} from 'utils/primeUtil';
import _get from 'lodash.get';
import {
  // PRC_FOR_SUBSCRIBED,
  TOI_SUBS_PLAN_TRANSLATION_WEB,
  TOI_SUBS_PLAN_TRANSLATION_MWEB,
  IMAGE_URL,
  PRC_FOR_NEVER_REGISTER,
  PRC_FOR_NOT_LOGIN,
  TIMES_HEALTH_URL,
  TIMES_HEALTH_IMG,
} from 'constants/index';
import { getGa4PageViewSet, collectEventfireGa4 } from 'utils/common';
import { loginEventEmitter, logOutEventEmitter } from 'components/Login';
import ErrorBoundary from 'components/ErrorBoundary';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import makeRequest from 'utils/makeRequest';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { handlePlanClick } from 'components/ToiSubscription/utils/payment';
import { connect } from 'react-redux';
import {
  HealthBannerAnchor,
  HealthBannerCloseIcon,
  HealthBannerStyledImage,
  HealthBannerWrapper,
} from 'routes/primeuserhome/components/desktop/TimesHealthStrip/TimesHealthStripStyledComponent';
import s from './toipNudges.scss';
// import ElementInView from '../ElementInView/ElementInView';
import StoryBlokcerV3 from './StoryBlockerV3/StoryBlokcerV3';

const HomePageNudge = React.lazy(() => import('./HomePageNudge'));
// const StoryBlockerNew = React.lazy(() =>
//   import('components_v2/common/ToipNudges/StoryBlockerNew/StoryBlockerNew'),
// );
const PrimeRenewStrip = React.lazy(() =>
  import('./PrimeRenewStrip/PrimeRenewStrip'),
);

const HomePageRenewNudge = React.lazy(() =>
  import('components_v2/mobile/HomePageRenewNudge/HomePageRenewNudge'),
);

const ToipNudges = ({
  viewType,
  showToiPlusNudges,
  isToiPlusAllowReadOnly,
  isWapView,
  userData,
  msid,
  title,
  isPrime,
  frmapp,
  isAppView,
  geo,
  storyTitle,
  userPrcData,
  transLoading,
  unifiedNodes,
  // showBundleCardMessage,
  shouldShowPopUp,
  blockerPopUp,
  showFreeTrailBlocker,
  closePopUpRef,
  siteConfig,
  translationData,
}) => {
  const healthStripConfig = _get(translationData, 'healthStripNudge', {});
  
  const [hasMounted, setHasMounted] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState('LOADING');
  const [nudgeHeight, setNudgeHeight] = useState('');
  const [isGracePeriod, setGracePeriod] = useState(false);
  const [graceDate, setGraceDate] = useState('');
  const [daysRemaining, setDaysRemaining] = useState(false);
  const [ispreExpired, setIsPreExpired] = useState(false);
  const [accessPayload, setaccessPayload] = useState({});
  const isToiPlusAllowReadOnlyRef = useRef(false);
  const [userType, setUserType] = useState(null);
  const [scrollDirection, setScrollDirection] = useState(false);
  const [oldValue, setOldValue] = useState(0);
  const [isTimesHealthClosing, setIsTimesHealthClosing] = useState(false);
  const [isTimesHealthVisible, setIsTimesHealthVisible] = useState(false);
  const LOCALSTORAGE_KEY = 'timesHealthStripClosedAtTOIPHome';
  const HOURS_24 = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  // Check on mount if the banner should be visible
  useEffect(
    () => {
      const closedAt = localStorage.getItem(LOCALSTORAGE_KEY);
      const now = Date.now();

      // eslint-disable-next-line radix
      if (!closedAt || now - parseInt(closedAt) > HOURS_24) {
        setIsTimesHealthVisible(true);
      }
    },
    [isTimesHealthVisible],
  );

  const fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: obj?.action === 'click' ? 'select_item' : 'view_item_list',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: msid || '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2: obj?.item_category2 || 'N/A',
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
    });
  };
  const handleClose = () => {
    setIsTimesHealthClosing(true);
    localStorage.setItem(LOCALSTORAGE_KEY, Date.now().toString());
    setIsTimesHealthVisible(false);
    const grxParams = [
      'timesHealth_top_banner_close_button_toiplus_landing_click',
      {
        client_source: 'cdp',
        event_nature: 'click',
        event_category: 'timeshealth_banner_close_button_toiplus_landing',
        cta_text: '',
      },
    ];
    if (typeof window !== 'undefined') {
      if (
        typeof window.grx !== 'undefined' &&
        typeof window.grx_module?.hitPaywallEventReact === 'function'
      ) {
        window.grx_module.hitPaywallEventReact(...grxParams);
      } else if (
        window.Times &&
        typeof window.Times.setGRXDataInLocalStorage === 'function'
      ) {
        window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
          eventName: grxParams[0],
          payload: grxParams[1],
        });
      }
    }
    fireGA4({
      action: 'click',
      item_category3: 'times_Health_banner_closed',
      item_category2: 'toiplus_landing',
      item_category4: 'close_button',
    });
  };
  const handleAnchorClick = () => {
    fireGA4({
      action: 'click',
      item_category3: 'timesHealth_banner_click',
      item_category2: 'toiplus_landing',
      item_category4: 'start_your_journey_banner',
    });
    const grxParams = [
      'timesHealth_top_banner_toiplus_landing_click',
      {
        client_source: 'cdp',
        event_nature: 'click',
        event_category: 'timeshealth_banner_toiplus_landing',
        cta_text: 'start_your_journey',
      },
    ];
    if (typeof window !== 'undefined') {
      if (
        typeof window.grx !== 'undefined' &&
        typeof window.grx_module?.hitPaywallEventReact === 'function'
      ) {
        window.grx_module.hitPaywallEventReact(...grxParams);
      } else if (
        window.Times &&
        typeof window.Times.setGRXDataInLocalStorage === 'function'
      ) {
        window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
          eventName: grxParams[0],
          payload: grxParams[1],
        });
      }
    }
  };
  const TimesHealthStrip = () => (
    <HealthBannerWrapper isClosing={isTimesHealthClosing}>
      <HealthBannerCloseIcon onClick={handleClose}>×</HealthBannerCloseIcon>
      <HealthBannerAnchor
        href={healthStripConfig.ctaLink}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleAnchorClick}
      >
        <HealthBannerStyledImage
          src={healthStripConfig.imageLink}
          alt="Times Health Banner Strip"
        />
      </HealthBannerAnchor>
    </HealthBannerWrapper>
  );
  const showFreeTrailBlockerRef = useRef(showFreeTrailBlocker);

  const isLoggedIn =
    userData && userData.isLoggedIn ? userData.isLoggedIn : undefined;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;

  const inViewGA = pageType => {
    let category = '';
    let action =
      pageType === 'toiplusprimeshow' || 'newtoiplusprimeshow'
        ? 'prime-login_blocker_Radio|View'
        : 'prime-login_blocker|View';
    if (isToiPlusAllowReadOnlyRef.current) {
      action = 'blocked_prime-login_blocker|View';
    }

    switch (pageType) {
      case 'toiplushomepage':
        if (isWapView) {
          category = 'WAP-primehome';
        } else {
          category = 'WEB-Prime-Home';
        }
        break;
      case 'toiplusprimeshow':
        category = isWapView ? 'WAP-newprimeshow' : 'WEB-newprimeshow';
        break;
      case 'newtoiplusprimeshow':
        category = isWapView ? 'WAP-newprimeshow' : 'WEB-newprimeshow';
        break;
      default:
        if (isWapView) {
          category = 'WAP-primelist';
        } else {
          category = 'WEB-Prime-HPListing';
        }
    }

    // if (isWapView) {
    //   category = 'WAP-primehome';
    // } else if (isHomePage) {
    //   category = 'WEB-Prime-Home';
    // } else {
    //   category = 'WEB-Prime-HPListing';
    // }
    analyticsWrapper(
      'ga',
      'send',
      'event',
      category,
      action,
      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
    );
  };

  useEffect(
    () => {
      setHasMounted(true);
      if (userPrcData) {
        checkGracePeriod(userPrcData).then(res => {
          setGracePeriod(res);
        });
        getGraceFormattedTime(userPrcData).then(res => {
          setGraceDate(res);
        });
        getPreExpiryFormattedTime(userPrcData).then(res => {
          setDaysRemaining(res);
        });
        checkPreExpireDate(userPrcData).then(res => {
          setIsPreExpired(res);
        });
        setaccessPayload(getUserAccessPayload());
      }
    },
    [userPrcData],
  );
  useEffect(
    () => {
      isToiPlusAllowReadOnlyRef.current = isToiPlusAllowReadOnly;
    },
    [isToiPlusAllowReadOnly],
  );

  useEffect(
    () => {
      if (userPrcData) {
        checkNewUser(userPrcData).then(res => {
          setUserType(res);
        });
      }
    },
    [userPrcData],
  );
  useEffect(() => {
    window.addEventListener('scroll', () => {
      // Get the new Value
      const newValue = window.pageYOffset;

      //Subtract the two and conclude
      if (oldValue - newValue > 0 && newValue > 50) {
        setScrollDirection(true);
      } else {
        setScrollDirection(false);
      }
      // Update the old value
      setOldValue(newValue);
    });
  });

  useEffect(
    () => {
      showFreeTrailBlockerRef.current = showFreeTrailBlocker;
    },
    [showFreeTrailBlocker],
  );

  const Loader = () => {
    if (viewType === 'toiplusprimeshow') {
      return (
        <LoaderSpinner
          overwriteWrapper={s.spinnerwrapper}
          overwriteLoader={s.spinner}
        />
      );
    }
    if (
      viewType === 'newtoiplusprimeshow' ||
      viewType === 'toiplusprimeshowV3'
    ) {
      return <img src={`${IMAGE_URL}99553042.cms`} alt="shimmer" />;
    }
    return null;
  };

  const getLoadingStatus = status => {
    setLoadingStatus(status);
  };

  const getNudgeHeight = (height = 0) => {
    setNudgeHeight(height);
  };

  const fireGA = action => {
    const innerCategory = isWapView ? 'wap-newprimeshow' : 'web-newprimeshow';
    if (typeof window !== 'undefined') {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        innerCategory,
        action,
        `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
      );
    }
  };

  const fireInViewGAandCDP = useCallback(() => {
    const showFreeTrail = showFreeTrailBlockerRef.current;
    const grxParams = [
      'subscriptions_blocker',
      {
        client_source: 'cdp',
        event_nature: 'impression',
        event_category: 'subscription',
        cta_text: '',
        paywalling_type: showFreeTrail ? 'free_trial' : '',
      },
    ];
    if (
      typeof window?.grx !== 'undefined' &&
      typeof window?.grx_module?.hitPaywallEventReact === 'function'
    ) {
      window.grx_module.hitPaywallEventReact(...grxParams);
    } else {
      window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
        eventName: grxParams[0],
        payload: grxParams[1],
      });
    }
    fireGA4({
      action: 'view',
      item_category2: showFreeTrail ? 'articleshow_free_Trial' : 'articleshow',
    });
  }, []);

  const onPlanClickHandler = async () => {
    fireGA('prime-login_blocker_Radio_CTA');
    const geoCountry = getGeoCountry() || 'IN';
    let url;
    if (isWapView) {
      url = `${TOI_SUBS_PLAN_TRANSLATION_WEB}&cc=${geoCountry}`;
    } else {
      url = `${TOI_SUBS_PLAN_TRANSLATION_MWEB}&cc=${geoCountry}`;
    }

    const translationApiRes = await makeRequest.get(url);
    const { data: translationData = {} } = translationApiRes;
    //const selectedPlan = await getSubscriptionPlan(geoCountry, isWapView);
    handlePlanClick(
      null,
      translationData,
      userData,
      isWapView,
      getGeoCountry(),
      // selectedPlan,
      {
        // selectedPlan,
        isGracePeriod,
        ispreExpired,
        userType,
        daysRemaining,
        pageType: viewType,
        justPayRedirect: true,
        offer: false,
      },
    );
  };

  const getLoginComponent = () => {
    const intiaiteLogin = e => {
      fireGA('prime-login_blocker|LoginCTA');
      loginEventEmitter(undefined, {});
      if (blockerPopUp && closePopUpRef?.current) {
        closePopUpRef.current(e, false);
      }
      let category;
      if (blockerPopUp) {
        category = 'paywall_bottomsheet_blocker_alreadySubscribed';
      } else if (showFreeTrailBlocker) {
        category = 'paywall_blocker_alreadySubscribed_freeTrial';
      } else {
        category = 'paywall_blocker_alreadySubscribed';
      }
      fireGA4({
        action: 'click',
        item_category4: e.target.innerText || '',
        item_category3: category,
        item_category2: 'articleshow',
      });
    };
    const checkintiaiteLogin = e => {
      if (isLoggedIn) {
        window.showLogoutToastMsg = true;
        logOutEventEmitter();
        setTimeout(() => {
          intiaiteLogin(e);
        }, 1000); //todo: improve this check
      } else {
        intiaiteLogin(e);
      }
    };
    return (
      <div
        className={`${s.login} ${
          !showFreeTrailBlockerRef.current ? s.space : ''
        }`}
      >
        Already a Member?
        <a onClick={e => checkintiaiteLogin(e)} className={s.loginLink}>
          {showFreeTrailBlockerRef.current ? 'Sign in' : 'Sign In Now'}
        </a>
      </div>
    );
  };
  const renderUI = () => {
    if (Object.keys(userData).length > 0) {
      switch (viewType) {
        case 'toiplushomepage':
          return isTimesHealthVisible &&
            !isWapView &&
            siteConfig?.isTimesHealthBannerVisible === 'true' &&
            healthStripConfig.imageLink ? (
            <div className={s.timesHealthStripWrapper}>
              <TimesHealthStrip />
            </div>
          ) : (
            <InViewObserver
              className={`${s.nudge_sticky} ${
                userData.prcValue === PRC_FOR_NEVER_REGISTER ||
                userData.prcValue === PRC_FOR_NOT_LOGIN
                  ? s.sticky
                  : ''
              } ${scrollDirection ? s.scrollup : s.scrolldown}`}
              inViewCallback={() => {
                inViewGA(viewType);
              }}
              viewMargin="0px 0px 0px 0px"
            >
              <div
                className={`${s.nudge_wraper} ${
                  loadingStatus === 'DONE' ? s.loaded : ''
                } ${isGracePeriod ? s.graceUser : ''}`}
                style={{
                  height: nudgeHeight,
                  ...(nudgeHeight === 0 ? { margin: 0 } : {}),
                }}
              >
                <HomePageNudge
                  viewType={viewType}
                  isWapView={isWapView}
                  userData={userData}
                  isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                  inGracePeriod={isGracePeriod}
                  graceDate={graceDate}
                  daysRemaining={daysRemaining}
                  ispreExpired={ispreExpired}
                  accessPayload={accessPayload}
                  frmapp={frmapp}
                  geo={geo?.currentCountry}
                  getLoadingStatus={getLoadingStatus}
                  getNudgeHeight={getNudgeHeight}
                  userPrcData={userPrcData}
                  unifiedNodes={unifiedNodes}
                />
              </div>
            </InViewObserver>
          );

        case 'toiplusplanpage':
          return null;
        case 'newtoiplusprimeshow':
          return null;

        case 'storyRenewStrip':
          return (
            <div
              className={`${s.nudge_wraper} ${
                loadingStatus === 'DONE' ? s.loaded : ''
              } ${isGracePeriod ? s.graceUser : ''}`}
              style={{ height: nudgeHeight }}
            >
              <PrimeRenewStrip
                isWapView={isWapView}
                title={title}
                userData={userData}
                msid={msid}
                accessPayload={accessPayload}
                isPrime={isPrime}
                isAppView={isAppView}
                userPrcData={userPrcData}
                getNudgeHeight={getNudgeHeight}
                inGracePeriod={isGracePeriod}
                graceDate={graceDate}
                daysRemaining={daysRemaining}
                ispreExpired={ispreExpired}
              />
            </div>
          );
        case 'ToiHpRenewNudge':
          return (
            <div
              className={`${s.nudge_wraper} ${
                loadingStatus === 'DONE' ? s.loaded : ''
              } ${isGracePeriod ? s.graceUser : ''}`}
              style={{ height: nudgeHeight, marginBottom: '16px' }}
            >
              <HomePageRenewNudge
                userData={userData}
                isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                inGracePeriod={isGracePeriod}
                graceDate={graceDate}
                daysRemaining={daysRemaining}
                ispreExpired={ispreExpired}
                userPrcData={userPrcData}
                getNudgeHeight={getNudgeHeight}
              />
            </div>
          );
        case 'toiplusprimeshowV3':
          return (
            <InViewObserver
              inViewCallback={fireInViewGAandCDP}
              viewMargin="0px 0px 0px 0px"
            >
              <StoryBlokcerV3
                loginComponent={getLoginComponent()}
                onPlanClickHandler={onPlanClickHandler}
                isWapView={isWapView}
                userData={userData}
                storyTitle={storyTitle}
                msid={msid}
                isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                userPrcData={userPrcData}
                getLoadingStatus={getLoadingStatus}
                shouldShowPopUp={shouldShowPopUp}
                blockerPopUp={blockerPopUp}
                closePopUpRef={closePopUpRef}
              />
            </InViewObserver>
          );
        default: {
          return (
            <InViewObserver
              className={s.nudge_sticky}
              inViewCallback={() => {
                inViewGA(viewType);
              }}
              viewMargin="0px 0px 0px 0px"
            >
              <div
                className={`${s.nudge_wraper} ${
                  loadingStatus === 'DONE' ? s.loaded : ''
                } ${isGracePeriod ? s.graceUser : ''}`}
                style={{
                  height: nudgeHeight,
                  ...(nudgeHeight === 0 ? { margin: 0 } : {}),
                }}
              >
                <HomePageNudge
                  viewType={viewType}
                  isWapView={isWapView}
                  userData={userData}
                  isToiPlusAllowReadOnly={isToiPlusAllowReadOnly}
                  inGracePeriod={isGracePeriod}
                  graceDate={graceDate}
                  daysRemaining={daysRemaining}
                  ispreExpired={ispreExpired}
                  accessPayload={accessPayload}
                  frmapp={frmapp}
                  geo={geo?.currentCountry}
                  getLoadingStatus={getLoadingStatus}
                  getNudgeHeight={getNudgeHeight}
                  userPrcData={userPrcData}
                  unifiedNodes={unifiedNodes}
                />
              </div>
            </InViewObserver>
          );
        }
      }
    }
    return null;
  };
  useEffect(
    () => {
      if (siteConfig?.isTimesHealthBannerVisible === 'true') renderUI();
    },
    [isTimesHealthVisible],
  );
  if (
    isTimesHealthVisible &&
    !isWapView &&
    siteConfig?.isTimesHealthBannerVisible === 'true' &&
    viewType === 'toiplushomepage'
  )
    return (
      <div className={s.timesHealthStripWrapper}>
        {healthStripConfig.imageLink && <TimesHealthStrip />}
      </div>
    );
  if (
    !showToiPlusNudges &&
    viewType !== 'toiplusprimeshow' &&
    viewType !== 'newtoiplusprimeshow' &&
    viewType !== 'storyRenewStrip' &&
    viewType !== 'toiplusprimeshowV3'
  ) {
    return null;
  }
  return (
    <ErrorBoundary>
      {(!hasMounted ||
        (loadingStatus === 'LOADING' && transLoading !== 'DONE') ||
        transLoading === 'LOADING') && <Loader />}
      {hasMounted && <Suspense fallback={<div />}>{renderUI()}</Suspense>}
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  transLoading: state.translationConfig.transLoading,
  showToiPlusNudges: state.toiplusconfig?.showToiPlusNudges,
  isToiPlusAllowReadOnly: state.toiplusconfig?.isToiPlusAllowReadOnly,
  userPrcData: state.login.userPrcData,
  unifiedNodes: _get(state, 'translationConfig.nudges.unifiedNodes', {}),
  siteConfig: state.common?.siteConfig,
  translationData: _get(state, 'translationConfig.nudges', {}),
});

export default React.memo(connect(mapStateToProps)(ToipNudges));

ToipNudges.propTypes = {
  viewType: PropTypes.string,
  isWapView: PropTypes.bool,
  userData: PropTypes.shape({
    prcValue: PropTypes.number,
    isLoggedIn: PropTypes.bool,
  }),
  msid: PropTypes.string,
  isToiPlusAllowReadOnly: PropTypes.bool,
  frmapp: PropTypes.bool,
  isAppView: PropTypes.bool,
  title: PropTypes.string,
  isPrime: PropTypes.bool,
  geo: PropTypes.shape({
    currentCountry: PropTypes.string,
  }),
  storyTitle: PropTypes.string,
  transLoading: PropTypes.string,
  shouldShowPopUp: PropTypes.func,
  blockerPopUp: PropTypes.bool,
  showFreeTrailBlocker: PropTypes.bool,
  translationData: PropTypes.shape({
    healthStripNudge: PropTypes.shape({
      ctaLink: PropTypes.string,
      ctaTxt: PropTypes.string,
      imageLink: PropTypes.string,
    }),
  }),
};

ToipNudges.defaultProps = {
  viewType: '',
  isWapView: false,
  userData: PropTypes.shape({
    prcValue: undefined,
    isLoggedIn: false,
  }),
  msid: '',
  isToiPlusAllowReadOnly: false,
  frmapp: false,
  isAppView: false,
  title: '',
  isPrime: false,
  geo: {},
  storyTitle: '',
  transLoading: '',
  blockerPopUp: false,
  shouldShowPopUp: () => {},
  showFreeTrailBlocker: false,
  translationData: {
    healthStripNudge: {},
  },
};
